import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=d745558e&"
import script from "./dict.vue?vue&type=script&lang=ts&"
export * from "./dict.vue?vue&type=script&lang=ts&"
import style0 from "./dict.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports